var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-card theme-border-color"},[(_vm.cardTitle)?_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.cardTitle))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }